/* eslint-disable no-undef-init */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-shadow */
import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Calendar } from 'react-date-range';
import moment from 'utils/moment';
import scheduleStyle from '../../../../Badging/Scheduling/Scheduling.module.scss';
import Button from '../../../../../components/button/button';
import Loading from '../../../../../components/loading';
import { fetchSchedules, fetchspecificAdpLogs, scheduleAppointment,
  fetchScheduleSlotsByDate, clearScheduleSlotsAction } from '../../../redux/action';

const Scheduling=(props) => {
  const dispatch = useDispatch();

  const { logData,
    adpDetails, avpDetailsPage, changePage, getLatestAvpDetails, handleGetLatestADPDetails } = props;
  const actionScheduleFetch= useSelector(state => state?.permitManagement?.actionScheduleFetch);
  const actionPortalTrainingsFetch = useSelector(state => state?.permitManagement?.actionPortalTrainingsFetch);
  const { adpAvpCancelAplicationAction } = useSelector(state => state?.permitManagement);
  const scheduleList = useSelector(state => state?.permitManagement?.scheduleList);
  const scheduleSlots = useSelector(state => state?.permitManagement?.scheduleSlots);
  const actionScheduled = useSelector(state => state?.permitManagement?.actionScheduled);
  const actionScheduleSlotsFetch = useSelector(state => state?.permitManagement?.actionScheduleSlotsFetch);
  const permitCategory = useSelector(state => state.permitManagement?.specificLog?.category_of_adp);
  const [cancelDetails, handleCancelDetails] = useState({ openCancelPopup: false, cancelRemarks: '', cancelShowError: false });
  const { id } = useParams();
  const initialState = {
    selected_date: new Date(),
    selected_time_slot: '',
    useCalendarData: {},
    available_time_slots: [],
    person_details: {},
    dataError: false,
    useDisableDates: []
  };
  const [schedule_data, handleScheduleData] = useState(initialState);
  const [apiSuccessMsg, handleApiStatus] = useState({ apiSuccessMessage: '', apiSuccess: false, loading: false, isDisableDateFun: false });
  const [fieldErrors, handleFieldError] = useState({
    useFieldError: false
  });
  const [init, setInit] = useState(false);
    const [blockedDate, setBlockedDate] = useState([]);
    const [startTimeInMinutes, setStartTimeInMinutes] = useState([]);
    const [endTimeInMinutes, setEndTimeInMinutes]= useState([]);
    const [blockedDates, setBlockedDates]= useState([]);

  const { selected_time_slot, useCalendarData, airportData, available_time_slots,
    utcSlotStartDate, utcSlotEndDate, useDisableDates } = schedule_data;
  const duration_slot = useCalendarData?.settings?.schedule_duration === '1' ? 60 : Number(useCalendarData?.settings?.schedule_duration);
  const scheduleBasedCategory = useCalendarData?.settings?.advanced_settings?.filter(ele => ele.schedule_category === permitCategory);
  let slot_duration = undefined;
    if (scheduleBasedCategory && scheduleBasedCategory.length>0) {
    slot_duration = scheduleBasedCategory[0]?.schedule_duration;
  } else {
    slot_duration = duration_slot;
  }

  const handleCheckPastSlotsOftheDay = (selectedVal, startVal) => {
    if (moment(selectedVal).isAfter(moment(), 'day')) {
      return true; // FOR FUTURE DATES NO NEED TO CHECK PAST SLOTS OF THE DAY
    }
    return startVal.isSameOrAfter(moment());
  };

  const createTimeSlots = (fromTime, toTime, slotDuration, calDate) => {
    let startTime = moment(fromTime, 'HH:mm');
    const endTime = moment(toTime, 'HH:mm');
    const slotList = [];
    const verifyTests = verifyNumberOfTests();
    if (verifyTests) {
      while (
        startTime.isSame(endTime) || startTime.isBefore(endTime)
      ) {
        if (slotDuration === undefined || Number.isNaN(slotDuration)) {
          break;
        }
        const endTimeCheck = moment(toTime, 'HH:mm').subtract(slotDuration, 'minute');

        if (
          (startTime.isSame(endTimeCheck) || startTime.isBefore(endTimeCheck))
          && calDate && handleCheckPastSlotsOftheDay(calDate, startTime)
        ) {
          slotList.push(startTime.format('HH:mm'));
        }

        startTime = startTime.add(slotDuration, 'minute');
      }
    }
    return slotList;
  };

  useEffect(() => {
      if (!scheduleList && logData?.settings?.scheduleEnable && ([2, 6, 11].includes(logData?.status))) {
        dispatch(fetchSchedules());
      }
      if (actionScheduleFetch.success && scheduleList && actionPortalTrainingsFetch?.success) {
        const todayDate = new Date();
        todayDate.setHours(0, 0, 0, 0);
        if (scheduleList?.calender) {
          handleDateChange(scheduleList.calender, scheduleList?.airport, todayDate, true);
          const parsedBlockedDate = scheduleList?.calender?.settings?.blocked_details?.map(ele => !ele.start_time && ele.block_date) || [];
          setBlockedDate(parsedBlockedDate);
        }
      }
    }, [scheduleList, logData?.settings?.scheduleEnable]);

  const verifyNumberOfTests = () => {
    if (scheduleBasedCategory && scheduleBasedCategory.length>0 && scheduleSlots?.length>0 && permitCategory) {
      const scheduleBased = scheduleSlots.filter(ele => ele.adp_info?.category === permitCategory);
      if (Number(scheduleBased?.length) >= Number(scheduleBasedCategory[0]?.schedule_tests)) {
        return false;
      }
    }
    return true;
  };

  function getDayIndex(weekday) {
    const weekdays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
    return weekdays.indexOf(weekday);
  }

  const handleGetAvailbleDates = (weekday, selectedMonth) => {
    const today = new Date(selectedMonth);
    const currentMonth = today.getMonth();
    const dates = [];
    const targetDay = getDayIndex(weekday);
    today.setDate(1);
    while (today.getMonth() === currentMonth) {
      if (today.getDay() === targetDay) {
        dates.push(new Date(today));
      }
      today.setDate(today.getDate() + 1);
    }
    return dates;
  };

  const handleCalenderDates = (week_info, currentMonth) => {
    let unavaialbleDates = [];
    if (week_info) {
      Object.keys(week_info).forEach((eachWeek) => {
        if (week_info[eachWeek]?.length === 0) {
          unavaialbleDates = [...unavaialbleDates, ...handleGetAvailbleDates(eachWeek, currentMonth)];
        }
      });
    }
    return unavaialbleDates;
  };

  const handleDateChange = async (useCalendarData2, airportData2, date, getLoading) => {
    if (getLoading) handleApiStatus({ ...apiSuccessMsg, loading: true });
    let s = new Date(date);
    let f = new Date(date);
    s.setHours(0, 0, 0, 0);
    f.setHours(24, 59, 59, 99);
    s = s.toISOString();
    f = f.toISOString();
    let weekDay= moment(date).format('ddd');
    weekDay = weekDay.toUpperCase();
    await dispatch(fetchScheduleSlotsByDate(scheduleList?.calender?.id, s, f));
    let week_availablity_info = useCalendarData2?.settings?.week_availablity_info;
    if (useCalendarData2?.settings?.advanced_settings?.length > 0) {
      week_availablity_info = useCalendarData2?.settings?.advanced_settings?.find(cate => cate.schedule_category === permitCategory)
      ?.week_availablity_info || {};
    }
    const useAvailablityList = week_availablity_info?.[weekDay] || [];
    let getSlots = [];
    useAvailablityList.map((eachT) => {
      const takeSlot = createTimeSlots(eachT?.from?.value, eachT?.to?.value, slot_duration, date);
      getSlots = [...getSlots, ...takeSlot];
      return eachT;
    });
    const timeObjects = getSlots.map(time => new Date(`1970-01-01T${time}`));
    timeObjects.sort((a, b) => a - b);
    const sortedTimeSlots = timeObjects.map(time => time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }));
    dispatch(fetchScheduleSlotsByDate(scheduleList?.calender?.id, s, f));
    const disableDates = handleCalenderDates(week_availablity_info, date);
    let datecheck = useCalendarData2?.settings?.blocked_details?.map(ele => ele.start_time && moment(ele.block_date).format('l'));
    if (datecheck?.includes(moment(date).format('l'))) {
      handledisableTime(date, useCalendarData2?.settings?.blocked_details);
    } else {
      setStartTimeInMinutes('');
      setEndTimeInMinutes('');
      setBlockedDate([]);
    }
    handleScheduleData({ ...schedule_data,
      selected_date: date,
      available_time_slots: sortedTimeSlots,
      dataError: false,
      useCalendarData: useCalendarData2,
      airportData: airportData2,
      person_details: {},
      useDisableDates: disableDates,
      selected_time_slot: ''
    });
    handleApiStatus({ ...apiSuccessMsg, loading: false });
  };

  const handleSaveUpload = async () => {
    const payload = {
      calender: schedule_data?.useCalendarData?.id,
      start_ts: utcSlotStartDate,
      end_ts: utcSlotEndDate
    };
    const noErrors = fieldErrors && Object.keys(fieldErrors)?.every(k => (fieldErrors[k] === false));
    if (noErrors && payload.start_ts) {
      await dispatch(scheduleAppointment(id, payload));
    } else if (payload.start_ts === undefined) {
      handleScheduleData({ ...schedule_data, dataError: true });
    } else {
      handleFieldError({
        ...fieldErrors,
        useFieldError: true
      });
    }
  };

  const handleCloseCancelPopup = useCallback(() => {
    handleCancelDetails({
      ...cancelDetails,
      openCancelPopup: false,
      cancelRemarks: '',
      cancelShowError: false
    });
  }, []);

  useEffect(() => {
    if (adpAvpCancelAplicationAction?.loading === false && adpAvpCancelAplicationAction?.success === true) {
      if (adpDetails && handleGetLatestADPDetails) {
        handleGetLatestADPDetails();
        handleCloseCancelPopup();
      }
      if (avpDetailsPage && getLatestAvpDetails) {
        getLatestAvpDetails();
        handleCloseCancelPopup();
      }
    }
  }, [adpAvpCancelAplicationAction, avpDetailsPage, adpDetails, handleGetLatestADPDetails, getLatestAvpDetails, handleCloseCancelPopup]);

  const handleNavigate = (dateRange) => {
    const disableDates = handleCalenderDates(useCalendarData?.settings?.week_availablity_info, dateRange);
    handleScheduleData({ ...schedule_data,
      useDisableDates: disableDates
    });
  };

  const addTimeToSelectedDate = (timeToAdd) => {
    const newDate = new Date(schedule_data?.selected_date);

    const [hours, minutes] = timeToAdd.split(':');

    newDate.setHours(newDate.getHours() + parseInt(hours, 10));
    newDate.setMinutes(newDate.getMinutes() + parseInt(minutes, 10));
    handleScheduleData({ ...schedule_data,
      selected_time_slot: timeToAdd,
      utcSlotStartDate: moment(newDate).format(),
      utcSlotEndDate: moment(newDate).add(slot_duration, 'minutes').format() });
  };

  const handleSelectSlot = (value) => {
    addTimeToSelectedDate(value);
  };

  useEffect(() => {
    dispatch(fetchSchedules());
    if (actionScheduleFetch.success && scheduleList && actionPortalTrainingsFetch?.success) {
      const todayDate = new Date();
      todayDate.setHours(0, 0, 0, 0);
      if (scheduleList?.calender) {
        handleDateChange(scheduleList.calender, scheduleList?.airport, todayDate, true);
      }
    }
  }, [logData?.settings?.scheduleEnable]);

  useEffect(() => {
    if (actionScheduleSlotsFetch.success) {
      let finalSlots = [...schedule_data.available_time_slots];
      const verifyTests = verifyNumberOfTests();
      if (verifyTests) {
        scheduleSlots.forEach((eachVal) => {
          const slotTime = moment(eachVal.start_ts).format('HH:mm');
          finalSlots = finalSlots.filter(slot => slotTime !== slot);
        });
      } else {
        finalSlots = [];
      }
      handleScheduleData({ ...schedule_data, available_time_slots: finalSlots });
      dispatch(clearScheduleSlotsAction());
    }
  }, [actionScheduleSlotsFetch, scheduleSlots, scheduleList, slot_duration]);

  useEffect(() => {
    if (id) {
      dispatch(fetchspecificAdpLogs(id));
    }
  }, [id]);

  useEffect(() => {
   if (permitCategory && scheduleList?.calender) {
      const todayDate = new Date();
      todayDate.setHours(0, 0, 0, 0);
      handleDateChange(scheduleList.calender, scheduleList?.airport, todayDate, true);
   }
  }, [permitCategory, scheduleList]);

  useEffect(() => {
    if (actionScheduleSlotsFetch.loading === true) {
      handleApiStatus({ ...apiSuccessMsg, loading: true });
    }
    if (actionScheduleSlotsFetch.success === true) {
      handleApiStatus({ ...apiSuccessMsg, loading: false });
    }
  }, [actionScheduleSlotsFetch]);

  useEffect(() => {
    if (actionScheduled.success) {
      changePage('completed', 'completed');
    }
  }, [actionScheduled]);

  const timeToMinutes = (time) => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  };

  const convert12to24= (time12h) => {
    const [time, modifier] = time12h.split(' ');
    let [hours, minutes] = time.split(':');
    if (hours === '12') {
        hours = '00';
    }
    if (modifier === 'PM') {
        hours = parseInt(hours, 10) + 12;
    }
    return `${hours}:${minutes}`;
  };

  const handledisableTime =(date, blockTimes) => {
    const convertedTimes = blockTimes.map((time) => {
      if (time.start_time && moment(time.block_date).format('l') === moment(date).format('l')) {
        return {
          start_time: time?.start_time.label.includes('AM')
           || time.start_time.label.includes('PM') ? convert12to24(time.start_time.label) : time.start_time.label,
          end_time: time?.end_time.label.includes('AM')
            || time.end_time.label.includes('PM') ? convert12to24(time.end_time.label) : time.end_time.label,
          blockDate: time.block_date
        };
      }
      return {};
    });
    let removeempty =convertedTimes.filter(ele => Object.keys(ele).length !== 0) || [];
    if (removeempty && removeempty?.length > 0) {
      removeempty.forEach((item) => {
        const startTime = item.start_time;
        const endTime = item.end_time;
        setBlockedDates(prev => [...prev, item.blockDate]);
        setStartTimeInMinutes(prevStartTimes => [...prevStartTimes, timeToMinutes(startTime)]);
        setEndTimeInMinutes(prevEndTimes => [...prevEndTimes, timeToMinutes(endTime)]);
      });
    }
  };

  const blockDate = blockedDate.map(ele => new Date(moment(ele)));
  const useDates =[...useDisableDates, ...blockDate];
  const selectedDate = moment(schedule_data?.selected_date).format('YYYY-MM-DD');
  const hasToday = useDates.some(dateString => moment(dateString).format('YYYY-MM-DD') === selectedDate);

  return (
    <>
      <Loading loadingStatus={apiSuccessMsg?.loading || actionScheduled?.loading} />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #dadce0', padding: '15px' }}>
          <p style={{ margin: 0 }}>Confirmation</p>
      </div>
        <div className={scheduleStyle.Container}>
          <div className={scheduleStyle.Container1}>
            <div className={scheduleStyle.Container2} style={{ boxShadow: '0px  0px' }}>
              <div className={scheduleStyle.box}>
                <div className={scheduleStyle.aeroStyle}>
                  <div className={scheduleStyle.box1}>
                    <img className={scheduleStyle.imgstyle} src={airportData?.logo} alt="Aerosimple" />
                  </div>
                  <hr />
                  <div className={scheduleStyle.box3}>
                    <div style={{ color: '#7C869B', marginLeft: '25px', fontSize: '12px' }}>
                      <FormattedMessage id={airportData?.name || '-'} defaultMessage={airportData?.name} />
                    </div>
                    <div className={scheduleStyle.aeroStyle2}>
                      <FormattedMessage id={useCalendarData?.title || '-'} defaultMessage={useCalendarData?.title} />
                    </div>
                    <div style={{ color: '#7C869B', margin: '10px 0 0 25px' }}>
                      <img className={scheduleStyle.imgstyle1} src="https://cdn-icons-png.flaticon.com/128/1827/1827463.png" alt="Aerosimple" />
                      <span>
                        {slot_duration}
                        {' Min '}
                      </span>
                      {init && !available_time_slots?.length > 0 && (
                        <p style={{ marginTop: '10px' }}>
                          <FormattedMessage
                            id="scheduling.no_available_slots"
                            defaultMessage="No slots are available on this date. Please pick another date."
                          />
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                    <div>
                      <div className={scheduleStyle.title}>
                        <FormattedMessage id="scheduling.title" defaultMessage="Select date & time" />
                      </div>
                      {useCalendarData?.id && slot_duration && (
                        <div className={scheduleStyle.CalendarStyle}>
                          <Calendar
                            date={schedule_data?.selected_date}
                            dateFormat="yyyy-MM-DD"
                            onChange={(e) => { handleDateChange(useCalendarData, airportData, e, true); setInit(true); }}
                            color="#3A61A8"
                            disabledDay={(current) => {
                              const customDate = moment().format('MM-DD-YYYY');
                              return (
                                current
                                && (useDisableDates.includes(current) || current < moment(customDate, 'MM-DD-YYYY'))
                              );
                            }}
                            disabledDates={useDates}
                            style={{ fontSize: '0.9rem' }}
                            onShownDateChange={handleNavigate}
                          />
                        </div>
                      )}
                    </div>
                    <div className={scheduleStyle.thirdbox}>
                      <p className={scheduleStyle.thirdbox1}>
                        {moment(schedule_data?.selected_date).format('dddd, MMMM D')}
                      </p>
                      <div className={scheduleStyle.useTimeSty}>
                        {!hasToday && available_time_slots.map((time) => {
                          const timeInMinutes = timeToMinutes(time);
                          let disabled = false;
                          for (let i = 0; i < startTimeInMinutes.length; i++) {
                              const startTime = startTimeInMinutes[i];
                              const endTime = endTimeInMinutes[i];
                              const finalblockedDate = new Date(blockedDates[i]);
                              const finalSelectedDate = new Date(schedule_data?.selected_date);
                              const isSame = finalblockedDate.getUTCFullYear() === finalSelectedDate.getFullYear()
                                && finalblockedDate.getUTCMonth() === finalSelectedDate.getMonth()
                                && finalblockedDate.getUTCDate() === finalSelectedDate.getDate();
                              if (isSame && timeInMinutes >= startTime && timeInMinutes <= endTime) {
                                  disabled = true;
                                  break; // Exit loop early if disabled is true
                              }
                          }
                          return (
                            <div className={`${scheduleStyle.smallBox} ${selected_time_slot === time ? scheduleStyle.activeSlat : ''}`}
                            role="button" tabIndex={0}
                              onClick={() => !disabled && handleSelectSlot(time)} onKeyPress={() => !disabled && handleSelectSlot(time)}
                              style={{ cursor: disabled ? 'not-allowed': 'pointer', borderColor: disabled ? 'gray' : '#3a61a8' }}
                            >
                              <span style={{ color: disabled && 'gray' }}>
                                {time}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '2%', justifyContent: 'flex-end', padding: '15px', borderTop: '1px solid rgb(218,220,224)' }}>
          <Button
            action="secondary"
            onClick={() => {
              handleSaveUpload();
            }}
            translationID="wildlife.form.submit"
            defaultText="Submit"
          />
        </div>
    </>
  );
};
export default Scheduling;
